module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'nav-open': _vm.$sidebar.showSidebar
    }
  }, [_c('router-view'), _vm._v(" "), _c('side-bar', {
    attrs: {
      "type": "navbar",
      "sidebar-links": _vm.$sidebar.sidebarLinks
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('p', [_vm._v("Logout")])])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c770613!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 371
// module chunks = 1